<div class="overlay" (click)="closePopupOverlay($event)">
  <div class="booking-container" (click)="$event.stopPropagation()">
    <div class="booking-header">
      <div class="header-top">
        <div class="header-icon">
          <svg
            width="28"
            height="28"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
            <polyline points="9 22 9 12 15 12 15 22"></polyline>
          </svg>
        </div>
        <h1>Book a Table</h1>
      </div>
    </div>

    <div class="booking-scroll">
      <button class="close-btn" (click)="close()">
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.5"
        >
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>

      <div class="booking-content">
        <div class="section">
          <h3 class="section-title">Your Details</h3>

          <div class="form-fields">
            <div class="form-group" #nameField>
              <label for="name">Full Name</label>
              <input
                id="name"
                type="text"
                placeholder="Enter your name"
                [formControl]="nameControl"
                (keydown)="handleNameKeyDown($event)"
                (input)="sanitizeName()"
                [class.invalid]="nameControl.invalid && nameControl.touched"
              />

              @if (nameControl.invalid && nameControl.touched) {
                <div class="error">
                  @if (nameControl.errors?.["required"]) {
                    <small>Name is required.</small>
                  }
                  @if (nameControl.errors?.["minlength"]) {
                    <small>Name must be at least 3 characters.</small>
                  }
                  @if (nameControl.errors?.["pattern"]) {
                    <small
                      >Only alphabets are allowed (no numbers or spaces or
                      special characters).</small
                    >
                  }
                </div>
              }
            </div>

            <div class="form-group" #mobileField>
              <label for="mobile">Mobile Number</label>
              <input
                id="mobile"
                type="tel"
                maxlength="10"
                placeholder="Enter mobile number"
                [formControl]="mobileControl"
                (keypress)="allowOnlyNumbers($event)"
                [class.invalid]="mobileControl.invalid && mobileControl.touched"
              />

              @if (mobileControl.invalid && mobileControl.touched) {
                <div class="error">
                  @if (mobileControl.errors?.["required"]) {
                    <small>Mobile number is required.</small>
                  }
                  @if (mobileControl.errors?.["pattern"]) {
                    <small
                      >Enter a valid 10-digit mobile number starting with
                      6–9.</small
                    >
                  }
                </div>
              }
            </div>

            <div class="form-group" #emailField>
              <label for="email">Email Address</label>
              <input
                id="email"
                type="email"
                placeholder="Enter your email address"
                [formControl]="emailControl"
                [class.invalid]="emailControl.invalid && emailControl.touched"
              />

              @if (emailControl.invalid && emailControl.touched) {
                <div class="error">
                  @if (emailControl.errors?.["required"]) {
                    <small>Email is required.</small>
                  }
                  @if (emailControl.errors?.["email"]) {
                    <small>Enter a valid email address.</small>
                  }
                </div>
              }
            </div>
          </div>
        </div>

        <div class="section">
          <h3 class="section-title">Number of Guests</h3>

          <div class="guests-selector">
            <button class="counter-btn" (click)="decrementGuests()">
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.5"
              >
                <line x1="5" y1="12" x2="19" y2="12"></line>
              </svg>
            </button>

            <div class="guests-display">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
              >
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                <circle cx="9" cy="7" r="4"></circle>
                <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
              </svg>

              <span class="guests-count">{{ personsControl.value || 0 }}</span>
              <span class="guests-text">
                {{ (personsControl.value || 0) === 1 ? "Guest" : "Guests" }}
              </span>
            </div>

            <button class="counter-btn" (click)="incrementGuests()">
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.5"
              >
                <line x1="12" y1="5" x2="12" y2="19"></line>
                <line x1="5" y1="12" x2="19" y2="12"></line>
              </svg>
            </button>
          </div>
        </div>

        <div class="section">
          <h3 class="section-title">Select Date</h3>

          <div class="date-slider">
            <button class="nav-btn prev" (click)="scrollDates('left')">
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
              >
                <polyline points="15 18 9 12 15 6"></polyline>
              </svg>
            </button>

            <div class="date-cards" #dateCardsContainer>
              @for (date of availableDates; track date.value) {
                <div
                  class="date-card"
                  [class.active]="dateControl.value === date.value"
                  (click)="selectDate(date.value)"
                >
                  <span class="date-day">{{ date.day }}</span>
                  <span class="date-num">{{ date.date }}</span>
                  <span class="date-month">{{ date.month }}</span>
                </div>
              }
            </div>

            <button class="nav-btn next" (click)="scrollDates('right')">
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
              >
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
            </button>
          </div>
        </div>

        @if (slotsResponse) {
          <div class="section">
            <h3 class="section-title">Meal</h3>

            <div class="meal-chips">
              <div
                class="chip"
                [class.active]="selectedMeal === 'breakfast'"
                (click)="changeMeal('breakfast')"
              >
                <span>Breakfast</span>
                <small>
                  {{ slotsResponse?.breakfast?.openingTime }} -
                  {{ slotsResponse?.breakfast?.closingTime }}
                </small>
              </div>

              <div
                class="chip"
                [class.active]="selectedMeal === 'lunch'"
                (click)="changeMeal('lunch')"
              >
                <span>Lunch</span>
                <small>
                  {{ slotsResponse?.lunch?.openingTime }} -
                  {{ slotsResponse?.lunch?.closingTime }}
                </small>
              </div>

              <div
                class="chip"
                [class.active]="selectedMeal === 'dinner'"
                (click)="changeMeal('dinner')"
              >
                <span>Dinner</span>
                <small>
                  {{ slotsResponse?.dinner?.openingTime }} -
                  {{ slotsResponse?.dinner?.closingTime }}
                </small>
              </div>
            </div>
          </div>
        }

        @if (dateControl.value) {
          <div class="section">
            <h3 class="section-title">Available Time Slots</h3>

            @if (loadingTimeSlots) {
              <div class="time-slots">
                @for (s of [1, 2, 3, 4, 5, 6]; track $index) {
                  <div class="time-slot skeleton"></div>
                }
              </div>
            } @else {
              @if (filteredTimeSlots.length > 0) {
                <div class="time-slots">
                  @for (slot of filteredTimeSlots; track slot.time) {
                    <div
                      class="time-slot"
                      [class.active]="timeSlotControl.value === slot.time"
                      [class.disabled]="slot.isBooked"
                      (click)="!slot.isBooked && selectTimeSlot(slot)"
                    >
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                      >
                        <circle cx="12" cy="12" r="10"></circle>
                        <polyline points="12 6 12 12 16 14"></polyline>
                      </svg>

                      <span>{{ slot.time }}</span>

                      @if (slot.isBooked) {
                        <span class="slot-badge">Booked</span>
                      }
                    </div>
                  }
                </div>
              } @else {
                <div>No slots available for this selection.</div>
              }
            }
          </div>
        }

        <div class="price-summary">
          <div class="price-row">
            <span>Price per guest</span>
            <span>₹{{ minPricePerPerson }}</span>
          </div>
          <div class="price-row">
            <span>Number of guests</span>
            <span>{{ personsControl.value || 0 }}</span>
          </div>
          <div class="divider"></div>
          <div class="price-row total">
            <span>Total Amount</span>
            <span>₹{{ totalPrice }}</span>
          </div>
        </div>

        <div class="action-btns">
          <button type="button" class="btn btn-cancel" (click)="close()">
            Cancel
          </button>

          <button
            type="button"
            class="btn btn-confirm"
            (click)="confirm()"
            [disabled]="loading"
          >
            @if (loading) {
              <div class="spinner"></div>
              Booking...
            } @else {
              Confirm Booking
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
              >
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
            }
          </button>
        </div>
      </div>
    </div>

    @if (paymentLoading) {
      <div class="payment-loader-overlay">
        <div class="payment-loader">
          <div class="spinner"></div>
          <p>Processing payment, please wait...</p>
        </div>
      </div>
    }
  </div>
</div>
